export function valorPendente(vlr) {
  if (vlr === null || vlr === undefined || String(vlr).trim() === '') {
    return true;
  }
  const numero = Number(vlr);
  return !Number.isNaN(numero) && numero === 0;
}

export function guiaPendente(guia) {
  return guia == null || String(guia).trim() === '';
}

export function isFaturamentoPendente(item) {
  return (
    valorPendente(item && item.VLRLAUDO) || guiaPendente(item && item.GUIA)
  );
}

export function formatarDataFiltro(iso) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
  if (!match) return iso || '';
  return `${match[3]}/${match[2]}/${match[1]}`;
}

export function formatarValor(vlr) {
  const numero = Number(vlr);
  if (Number.isNaN(numero)) return String(vlr);
  return numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

export function deduplicar(lista) {
  const dados = Array.isArray(lista) ? lista : [];
  const vistos = new Set();
  return dados.filter(item => {
    const paciente = (item.NOMEPAC || '').trim();
    if (!paciente) return false;

    const chave = `${(
      item.dataFormatada || ''
    ).trim()}|${paciente.toUpperCase()}|${(item.NOMEMED || '')
      .trim()
      .toUpperCase()}`;

    if (vistos.has(chave)) return false;

    vistos.add(chave);

    return true;
  });
}

export const toggleItem = (setLista, valor, checked) => {
  setLista(prev =>
    checked ? [...prev, valor] : prev.filter(x => x !== valor)
  );
};
